import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data.user);
      if (res.data.csrf_token) sessionStorage.setItem("emerge_csrf", res.data.csrf_token);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = useCallback(async (identifier, password) => {
    const res = await api.post("/auth/login", { identifier, password });
    sessionStorage.setItem("emerge_csrf", res.data.csrf_token);
    setUser(res.data.user);
    return res.data.user;
  }, []);

  const applySession = useCallback((data) => {
    if (data?.csrf_token) sessionStorage.setItem("emerge_csrf", data.csrf_token);
    setUser(data.user);
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* ignore */
    }
    sessionStorage.removeItem("emerge_csrf");
    setUser(null);
  }, []);

  const value = useMemo(
    () => ({ user, loading, login, logout, refresh, applySession, isSupervisor: user?.role === "supervisor", setUser }),
    [user, loading, login, logout, refresh, applySession]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
